
// import React from 'react';
// import image from '../assets/BookRide.png'; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-4/5 w-full sm:p-10 lg:p-14">
//       <div className="relative w-full sm:w-3/5 h-auto opacity-100 flex justify-center">
//         <img
//           src={image}
//           alt="Centered"
//           className="object-cover w-full h-auto rounded-lg"
//         />
//       </div>
//     </div>
//   );
// }

// export default BookRide;


// import React from 'react';
// import image from '../assets/BookRide.png'; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-4/5 w-full sm:p-10 lg:p-14 relative">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 h-auto opacity-100 flex justify-center">
//         <img
//           src={image}
//           alt="Centered"
//           className="object-cover w-full h-auto rounded-lg"
//         />
//         {/* Text Overlay */}
//         <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white">
//           <div className=" bg-opacity-50 rounded-md p-4 text-black text-left">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold ">
//               Book a Bike
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg w-2/5">
//               Down the street or across the country, find the perfect bike for
//               your next adventure.
//             </p>
//           </div>
//           <div className=" bg-opacity-50 rounded-md p-4 mt-6 text-black text-right">
//             <h2 className=" text-lg sm:text-2xl lg:text-3xl font-bold ">
//               Become a Host
//             </h2>
//             <p className=" absolute text-sm sm:text-base lg:text-lg  w-2/5 text-right">
//               Start your bike-sharing business with MoveonWheels. Accelerate
//               your entrepreneurship today!
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;

// import React from "react";
// import image from "../assets/BookRide.png"; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-screen w-full px-6 py-10 lg:px-14 lg:py-20">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 h-auto">
//         <img
//           src={image}
//           alt="Book a Bike and Become a Host"
//           className="object-cover w-full h-auto rounded-lg"
//         />

//         {/* Text Overlay */}
//         <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
//           {/* Book a Bike Section */}
//           <div className="flex items-center justify-center mb-12 text-left">
//             <div className="bg-white bg-opacity-90 rounded-xl p-6 shadow-md flex flex-col items-center text-left">
//               <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 mb-2">
//                 Book a Bike
//               </h2>
//               <p className="text-sm sm:text-base lg:text-lg text-gray-700 w-64">
//                 Down the street or across the country, find the perfect bike for
//                 your next adventure.
//               </p>
//             </div>
//           </div>

//           {/* Become a Host Section */}
//           <div className="flex items-center justify-center mt-12">
//             <div className="bg-white bg-opacity-90 rounded-xl p-6 shadow-md flex flex-col items-center text-left">
//               <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 mb-2">
//                 Become a Host
//               </h2>
//               <p className="text-sm sm:text-base lg:text-lg text-gray-700 w-64">
//                 Start your bike-sharing business with MoveonWheels. Accelerate
//                 your entrepreneurship today!
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;

// import React from "react";
// import image from "../assets/BookRide.png"; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-screen w-full px-6 py-10 lg:px-14 lg:py-20">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 h-auto">
//         <img
//           src={image}
//           alt="Book a Bike and Become a Host"
//           className="object-cover w-full h-auto rounded-lg"
//         />

//         {/* Text Overlay */}
//         <div className="absolute inset-0 flex items-center justify-between px-4 sm:px-8">
//           {/* Book a Bike Section */}
//           <div className="bg-white bg-opacity-90 rounded-xl p-6 shadow-md text-left max-w-sm">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 mb-2">
//               Book a Bike
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Down the street or across the country, find the perfect bike for
//               your next adventure.
//             </p>
//           </div>

//           {/* Become a Host Section */}
//           <div className="bg-white bg-opacity-90 rounded-xl p-6 shadow-md text-left max-w-sm">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 mb-2">
//               Become a Host
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Start your bike-sharing business with MoveonWheels. Accelerate
//               your entrepreneurship today!
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;


// import React from "react";
// import image from "../assets/BookRide.png"; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-screen w-full  lg:px-14 lg:py-20">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 h-auto">
//         <img
//           src={image}
//           alt="Book a Bike and Become a Host"
//           className="object-cover w-full h-auto rounded-lg"
//         />

//         {/* Text Overlay */}
//         <div className="absolute inset-0 flex items-center justify-between px-6">
//           {/* Book a Bike Section */}
//           <div className=" bg-opacity-90 rounded-xl p-6  text-left max-w-xs">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 ">
//               Book a Bike
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Down the street or across the country, find the perfect bike for
//               your next adventure.
//             </p>
//           </div>

//           {/* Become a Host Section */}
//           <div className=" bg-opacity-90 rounded-xl p-6  text-left max-w-xs">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 mb-2">
//               Become a Host
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Start your bike-sharing business with MoveonWheels. Accelerate
//               your entrepreneurship today!
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;


// import React from "react";
// import image from "../assets/BookRide.png"; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-screen w-full lg:px-14 lg:py-20">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 h-auto">
//         <img
//           src={image}
//           alt="Book a Bike and Become a Host"
//           className="object-cover w-full h-auto rounded-lg"
//         />

//         {/* Text Overlay */}
//         <div className="absolute inset-0 flex flex-row justify-between items-center px-6 space-y-6">
//           {/* Book a Bike Section */}
//           <div className="bg-opacity-90 rounded-xl p-6 text-center max-w-xs">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600">
//               Book a Bike
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Down the street or across the country, find the perfect bike for
//               your next adventure.
//             </p>
//           </div>

//           {/* Become a Host Section */}
//           <div className="bg-opacity-90 rounded-xl p-6 text-center max-w-xs">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 mb-2">
//               Become a Host
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Start your bike-sharing business with MoveonWheels. Accelerate
//               your entrepreneurship today!
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;


// import React from "react";
// import image from "../assets/BookRide.png"; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-screen w-full lg:px-14 lg:py-20">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 h-auto">
//         <img
//           src={image}
//           alt="Book a Bike and Become a Host"
//           className="object-cover w-full h-auto rounded-lg"
//         />

//         {/* Text Overlay */}
//         <div className="absolute inset-0 flex justify-between  items-center px-6 space-y-6">
//           {/* Book a Bike Section */}
//           <div className="bg-opacity-90 rounded-xl p-6 text-center max-w-xs">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600">
//               Book a Bike
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Down the street or across the country, find the perfect bike for
//               your next adventure.
//             </p>
//           </div>

//           {/* Become a Host Section */}
//           <div className="bg-opacity-90 rounded-xl p-6 text-center max-w-xs">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 mb-2">
//               Become a Host
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Start your bike-sharing business with MoveonWheels. Accelerate
//               your entrepreneurship today!
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;


// import React from "react";
// import image from "../assets/BookRide.png"; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-screen w-full lg:px-14 lg:py-20">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 h-auto">
//         <img
//           src={image}
//           alt="Book a Bike and Become a Host"
//           className="object-cover w-full h-auto rounded-lg"
//         />

//         {/* Text Overlay */}
//         <div className="absolute inset-0">
//           {/* Book a Bike Section */}
//           <div className="absolute top-1/4 left-1/4 transform -rotate-12 bg-white bg-opacity-90 rounded-xl p-6 text-center max-w-xs shadow-lg">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600">
//               Book a Bike
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Down the street or across the country, find the perfect bike for
//               your next adventure.
//             </p>
//           </div>

//           {/* Become a Host Section */}
//           <div className="absolute bottom-1/4 right-1/4 transform rotate-12 bg-white bg-opacity-90 rounded-xl p-6 text-center max-w-xs shadow-lg">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 mb-2">
//               Become a Host
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Start your bike-sharing business with MoveonWheels. Accelerate
//               your entrepreneurship today!
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;

// import React from "react";
// import image from "../assets/BookRide.png"; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-screen w-full lg:px-14 lg:py-20">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 h-auto">
//         <img
//           src={image}
//           alt="Book a Bike and Become a Host"
//           className="object-cover w-full h-auto rounded-lg"
//         />

//         {/* Text Overlay */}
//         <div className="absolute inset-0">
//           {/* Book a Bike Section */}
//           <div className="absolute top-[20%] left-[15%] transform -rotate-12 bg-white bg-opacity-90 rounded-xl p-6 text-center max-w-xs shadow-lg">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600">
//               Book a Bike
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Down the street or across the country, find the perfect bike for
//               your next adventure.
//             </p>
//           </div>

//           {/* Become a Host Section */}
//           <div className="absolute bottom-[20%] right-[15%] transform rotate-12 bg-white bg-opacity-90 rounded-xl p-6 text-center max-w-xs shadow-lg">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-purple-600 mb-2">
//               Become a Host
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Start your bike-sharing business with MoveonWheels. Accelerate
//               your entrepreneurship today!
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;

// import React from "react";
// import image from "../assets/BookRide.png"; // Replace with the path to your image

// function BookRide() {
//   return (
//     <div className="flex items-center justify-center h-screen w-full lg:px-14 lg:py-20">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 h-auto">
//         <img
//           src={image}
//           alt="Book a Bike and Become a Host"
//           className="object-cover w-full h-auto rounded-lg"
//         />

//         {/* Text Overlay */}
//         <div className="absolute inset-0">
//           {/* Book a Bike Section */}
//           <div className="absolute top-[15%] left-[10%]   bg-opacity-90 rounded-xl p-6 text-center max-w-xs ">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-[#593CFB]">
//               Book a Bike
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Down the street or across the country, find the perfect bike for
//               your next adventure.
//             </p>
//           </div>

//           {/* Become a Host Section */}
//           <div className="absolute bottom-[10%] right-[10%] transform   bg-opacity-90 rounded-xl p-6 text-center max-w-xs ">
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-[#593CFB] mb-2">
//               Become a Host
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Start your bike-sharing business with MoveonWheels. Accelerate
//               your entrepreneurship today!
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import image from "../assets/BookRide.png"; // Replace with the path to your image

// function BookRide() {
//   const navigate = useNavigate();

//   return (
//     <div className="flex items-center justify-center  w-full lg:px-14 lg:py-20">
//       {/* Image Section */}
//       <div className="relative w-full sm:w-3/5 ">
//         <img
//           src={image}
//           alt="Book a Bike and Become a Host"
//           className="object-cover w-full h-auto rounded-lg"
//         />

//         {/* Text Overlay */}
//         <div className="absolute inset-0">
//           {/* Book a Bike Section */}
//           <div
//             onClick={() => navigate("/product")}
//             className="absolute top-[15%] left-[10%] bg-opacity-90 rounded-xl p-6 text-center max-w-xs cursor-pointer  transition"
//           >
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-[#593CFB]">
//               Book a Bike
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Down the street or across the country, find the perfect bike for
//               your next adventure.
//             </p>
//           </div>

//           {/* Become a Host Section */}
//           <div
//             onClick={() => navigate("/franchise")}
//             className="absolute bottom-[10%] right-[10%] bg-opacity-90 rounded-xl p-6 text-center max-w-sm cursor-pointer transition"
//           >
//             <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-[#593CFB] mb-2">
//               Become a Host
//             </h2>
//             <p className="text-sm sm:text-base lg:text-lg text-gray-700">
//               Accelerate your entrepreneurship and start building a small bike sharing
//               business on MoveonWheels.
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BookRide;

import React from "react";
import { useNavigate } from "react-router-dom";
import image from "../assets/BookRide.png"; // Replace with your image path

function BookRide() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center w-full px-4 py-8 lg:px-14 lg:py-20">
      {/* Image Section */}
      <div className="relative w-full md:w-3/5">
        <img
          src={image}
          alt="Book a Bike and Become a Host"
          className="object-cover w-full h-auto rounded-lg"
        />

        {/* Text Overlay */}
        <div className="absolute inset-0">
          {/* Book a Bike Section */}
          <div
            onClick={() => navigate("/product")}
            className="absolute top-[10%]  sm:left-[10%] bg-opacity-90 rounded-xl p-4 sm:p-6 md:text-center text-center md:max-w-xs w-3/5 cursor-pointer transition transform hover:scale-105"
          >
            <h2 className="text-base sm:text-xl lg:text-3xl font-bold text-[#593CFB]">
              Book a Bike
            </h2>
            <p className="text-xs sm:text-sm  lg:text-lg text-gray-700">
              Down the street or across the country, find the perfect bike for
              your next adventure.
            </p>
          </div>

          {/* Become a Host Section */}
          <div
            onClick={() => navigate("/franchise")}
            className="absolute bottom-[0%] right-[0%] sm:right-[10%] bg-opacity-90 rounded-xl p-4 sm:p-6 md:text-center text-center md:max-w-xs w-3/5 cursor-pointer transition transform hover:scale-105 "
          >
            <h2 className="text-base sm:text-xl lg:text-3xl font-bold text-[#593CFB]">
              Become a Host
            </h2>
            <p className="text-xs sm:text-sm lg:text-lg text-gray-700">
              Accelerate your entrepreneurship and start building a small bike-sharing
              business on MoveonWheels.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookRide;
